import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Read the Protocol',
    desc: 'Learn the biological "why" behind your wake-ups.'
  }, {
    num: '2',
    title: 'Prep Your Cave',
    desc: 'Implement the 5-minute Bedroom Audit tonight.'
  }, {
    num: '3',
    title: 'Flip the Switch',
    desc: 'Use the 18-minute routine the next time you wake up at 3 AM.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-night-900" data-id="element-114">
      <div className="max-w-5xl mx-auto" data-id="element-115">
        <FadeIn data-id="element-116">
          <h3 className="font-serif text-3xl md:text-4xl text-white mb-16 text-center" data-id="element-117">
            How It Works
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-118">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-night-700 z-0" data-id="element-119"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-120">
              <div className="flex flex-col items-center text-center" data-id="element-121">
                <div className="w-16 h-16 rounded-full bg-night-800 border-2 border-amber-500 flex items-center justify-center text-2xl font-serif text-amber-400 mb-6 shadow-glow" data-id="element-122">
                  {step.num}
                </div>
                <h4 className="text-xl font-bold text-white mb-3" data-id="element-123">
                  {step.title}
                </h4>
                <p className="text-cream/70 leading-relaxed max-w-xs" data-id="element-124">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}